import React from 'react';
import LogoHorizontalSVG from 'volto-ministerio-publico-federal/components/Logo/LogoHorizontalSVG';
import useFormattedDate from 'volto-ministerio-publico-federal/hooks/useFormattedDate';

interface PrintMastheadProps {
  /** Data de publicação (`effective`), em ISO. Nem todo tipo tem uma. */
  effective?: string | null;
}

/**
 * Cabeçalho da folha impressa: marca do MPF à esquerda, data de publicação à
 * direita.
 *
 * A marca existe como componente próprio, e não revelando o logo do
 * cabeçalho do site, porque o `.mpf-topbar` é `sticky` e ancora mega menu e
 * painel mobile: mesmo neutralizado, ele colapsava sobre o título da notícia
 * na impressão e ainda deixava escapar o botão "…" do menu de opções do
 * mobile. O cabeçalho inteiro sai do papel (`theme/styles/_print.scss`) e a
 * marca entra por aqui.
 *
 * A data da IMPRESSÃO não fica aqui — vive na assinatura do `PrintFooter`,
 * para não repetir a mesma informação nas duas pontas da folha.
 *
 * Escondido na tela e revelado por `@media print`, pelo mesmo motivo do
 * `PrintFooter`: sem depender da utility `.block` do Tailwind.
 */
export const PrintMasthead: React.FC<PrintMastheadProps> = ({ effective }) => {
  const { formatShortWithTime } = useFormattedDate();

  return (
    <div className="mpf-print-masthead" aria-hidden="true">
      <LogoHorizontalSVG className="mpf-print-masthead__logo" />
      <div className="mpf-print-masthead__meta">
        {effective && <p>Publicado em {formatShortWithTime(effective)}</p>}
      </div>
    </div>
  );
};

export default PrintMasthead;
